// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerAccountViewZrmWebApiHandler_inquiries,
  RentalManagerAccountViewZrmWebApiHandler_inquiries_Path,
  RentalManagerAccountViewZrmWebApiHandler_leases,
  RentalManagerAccountViewZrmWebApiHandler_leases_Path,
  RentalManagerAccountViewZrmWebApiHandler_list,
  RentalManagerAccountViewZrmWebApiHandler_list_Path,
  RentalManagerAccountViewZrmWebApiHandler_payments,
  RentalManagerAccountViewZrmWebApiHandler_payments_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingsDto,
  AccountViewTableCellDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface InquiriesParams {
  listingAlias: ListingAlias;
}
interface LeasesParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface PaymentsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZrmWebApiHandler_inquiries_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, InquiriesParams]
>;

const RentalManagerAccountViewZrmWebApiHandler_inquiries_GetKey = (getParams: InquiriesParams) =>
  [RentalManagerAccountViewZrmWebApiHandler_inquiries_Path, getParams] as const;

export const RentalManagerAccountViewZrmWebApiHandler_inquiries_queryOptions = (getParams: InquiriesParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_inquiries_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_inquiries(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property inquiries status
 */
export const useRentalManagerAccountViewZrmWebApiHandler_inquiries = (
  getParams: InquiriesParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_inquiries_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmWebApiHandler_inquiries_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZrmWebApiHandler_inquiries.getKey =
  RentalManagerAccountViewZrmWebApiHandler_inquiries_GetKey;

export type RentalManagerAccountViewZrmWebApiHandler_leases_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, LeasesParams]
>;

const RentalManagerAccountViewZrmWebApiHandler_leases_GetKey = (getParams: LeasesParams) =>
  [RentalManagerAccountViewZrmWebApiHandler_leases_Path, getParams] as const;

export const RentalManagerAccountViewZrmWebApiHandler_leases_queryOptions = (getParams: LeasesParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_leases_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_leases(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property leases status
 */
export const useRentalManagerAccountViewZrmWebApiHandler_leases = (
  getParams: LeasesParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_leases_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmWebApiHandler_leases_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZrmWebApiHandler_leases.getKey = RentalManagerAccountViewZrmWebApiHandler_leases_GetKey;

export type RentalManagerAccountViewZrmWebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingsDto,
  unknown,
  AccountViewListingsDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZrmWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZrmWebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZrmWebApiHandler_list_queryOptions = (getParams: ListParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_list(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property list
 */
export const useRentalManagerAccountViewZrmWebApiHandler_list = (
  getParams: ListParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_list_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmWebApiHandler_list_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZrmWebApiHandler_list.getKey = RentalManagerAccountViewZrmWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZrmWebApiHandler_payments_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, PaymentsParams]
>;

const RentalManagerAccountViewZrmWebApiHandler_payments_GetKey = (getParams: PaymentsParams) =>
  [RentalManagerAccountViewZrmWebApiHandler_payments_Path, getParams] as const;

export const RentalManagerAccountViewZrmWebApiHandler_payments_queryOptions = (getParams: PaymentsParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmWebApiHandler_payments_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmWebApiHandler_payments(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view property payments status
 */
export const useRentalManagerAccountViewZrmWebApiHandler_payments = (
  getParams: PaymentsParams,
  options: Omit<RentalManagerAccountViewZrmWebApiHandler_payments_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmWebApiHandler_payments_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZrmWebApiHandler_payments.getKey = RentalManagerAccountViewZrmWebApiHandler_payments_GetKey;
